const MESSAGES = {
  EMAIL_TAKEN: 'An account already uses this email. Sign in instead, or reset the password if you forgot it.',
  EMAIL_INVITED: 'This email has an invitation waiting. Open the invite link in your email, or reset your password to set one.',
  INVALID_CREDENTIALS: 'That email and password do not match an account.',
  TOKEN_INVALID: 'This link is not valid. Ask for a new one.',
  TOKEN_EXPIRED: 'This link has expired. Ask for a new one.',
  TOKEN_USED: 'This link was already used. Ask for a new one if you still need it.',
  INVITE_ALREADY_ACCEPTED: 'This invitation was already accepted. Sign in with the password you set.'
};

/**
 * Turns a failed sign-in request into one sentence that says what happened and what to do.
 * Unknown failures keep the API's message; a dropped connection gets a plain retry line.
 */
const describeAuthFailure = (failure) => {
  if (failure?.status === 429) {
    return 'Too many attempts. Wait a few minutes, then try again.';
  }

  return MESSAGES[failure?.code] || failure?.message || 'Pieve could not be reached. Check your connection and try again.';
};

export default describeAuthFailure;
